import { connect, MapStateToProps } from 'react-redux';
import { ApplicationState } from '../../../store';
import { MediaInfo, MediaInfoProps } from './MediaInfo';
import './MediaInfo.css';

const mapStateToProps: MapStateToProps<MediaInfoProps, any, ApplicationState> = (state: ApplicationState, _) => ({
  media: state.medias.medias[state.timeline.selectedMediaId]
});

export const MediaInfoContainer = connect(
  mapStateToProps,
  null
)(MediaInfo);



// WEBPACK FOOTER //
// ./src/components/timeline/mediaInfo/MediaInfoContainer.ts